const changeNotificationTypeFilterReducer = (state, action) => {
  return {
    ...state,
    notificationTypeFilter: action.payload.type,
  };
};

export default changeNotificationTypeFilterReducer;
